export const operators = [
	{ firestore: '==', javascript: (a, b) => a === (Array.isArray(b) ? b[0] : b) },
	{ firestore: '!=', javascript: (a, b) => a !== (Array.isArray(b) ? b[0] : b) },
	{ firestore: '<', javascript: (a, b) => a < (Array.isArray(b) ? b[0] : b) },
	{ firestore: '<=', javascript: (a, b) => a <= (Array.isArray(b) ? b[0] : b) },
	{ firestore: '>', javascript: (a, b) => a > (Array.isArray(b) ? b[0] : b) },
	{ firestore: '>=', javascript: (a, b) => a >= (Array.isArray(b) ? b[0] : b) },
	{ firestore: 'array-contains', javascript: (a, b) => Array.isArray(a) && a.includes((Array.isArray(b) ? b[0] : b)) },
	{ firestore: 'array-not-contains', javascript: (a, b) => !(Array.isArray(a) && a.includes((Array.isArray(b) ? b[0] : b))) },
	{
		firestore: 'array-contains-any',
		javascript: (a, b) => Array.isArray(a) && (Array.isArray(b) ? b : [b]).some((value) => a.includes(value))
	},
	{
		firestore: 'array-not-contains-any',
		javascript: (a, b) => !(Array.isArray(a) && (Array.isArray(b) ? b : [b]).some((value) => a.includes(value)))
	},
	{ firestore: 'in', javascript: (a, b) => (Array.isArray(b) ? b : [b]).includes(a) },
	{ firestore: 'not-in', javascript: (a, b) => !(Array.isArray(b) ? b : [b]).includes(a) }
];
